import { render, staticRenderFns } from "./MallHead.vue?vue&type=template&id=933dd384&scoped=true&"
import script from "./MallHead.vue?vue&type=script&lang=js&"
export * from "./MallHead.vue?vue&type=script&lang=js&"
import style0 from "./MallHead.vue?vue&type=style&index=0&id=933dd384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933dd384",
  null
  
)

export default component.exports